// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__p-V5m","backgroundMobile":"App_backgroundMobile__-LN1Q","background":"App_background__IxVd3","appWrapperContent":"App_appWrapperContent__DdHDg"};